import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'billStatus': {
    title: '要货状态',
    type: 'select',
    equation: all,
    dictionary: 'wantgoodStatus',
    defaultVal: 'E002'
  },
  'handleNode': {
    title: '节点',
    type: 'select',
    dictionary: 'handeNode',
    defaultVal: ['销售内勤', '电商渠道'],
    dictionaryVal: [
      { name: '销售内勤', value: '销售内勤' },
      { name: '渠道经理', value: '渠道经理' },
      { name: '基地经理', value: '基地经理' },
      { name: '战区经理', value: '战区经理' },
      { name: '销售内勤', value: '销售内勤' },
      { name: '电商渠道', value: '电商渠道' },
      { name: '销售计划部', value: '销售计划部' }
    ]
  },
  'planType': {
    title: '计划类型',
    type: 'select',
    equation: all,
    dictionary: 'A0002'
  },
  'channelsType': {
    title: '渠道类型',
    type: 'select',
    equation: all,
    dictionary: 'A0054'
  },
  'wantCode': {
    title: '要货单编号',
    type: 'input',
    equation: all
  },
  'quotasYear': {
    title: '配额年度',
    type: 'year',
    equation: all
  },
  'createdDate': {
    title: '要货日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'saleCenter': {
    title: '营销单元',
    type: 'select',
    equation: cusname,
    dictionary: 'sale'
  },
  'customerCode': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'customerName': {
    title: '客户名称',
    type: 'input',
    equation: all
  },
  'productCode': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  },
  'productDesc': {
    title: '产品描述',
    type: 'input'
  },
  'ZZFLD000016': {
    title: '客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  'orderStatus': {
    title: '安吉货运状态',
    type: 'select',
    equation: all,
    dictionary: 'B0101'
  },
  'fillinDate': {
    title: '瓶储截止日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'sendTime': {
    title: '推送日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'kaStoreFullname': {
    title: 'KA卖场全称',
    type: 'input'
  },
  'kaStoreShortname': {
    title: 'KA卖场简称',
    type: 'input'
  },
  'kaStoreArea': {
    title: '卖场区域',
    type: 'input'
  },
  'cancelType': {
    title: '取消类型',
    type: 'select',
    equation: all,
    dictionary: 'cancelType'
  },
  'zzfld00001c': {
    title: '六位编码',
    type: 'input'
  },
  'remark': {
    title: '备注',
    type: 'input'
  },
}

export default {
  'wantCode': {
    title: '要货单号',
    slot: true,
    width: 110
  },
  'orderId': {
    title: '团购单号',
    type: 'input',
    width: 110
  },
  'zzfld00002j': {
    title: '团购订单类型',
    describe: true,
    type: 'select',
    suffix: 'TextView',
    equation: all,
    dictionary: 'A0057'
  },
  'orderStatusTextView': {
    title: '安吉货运状态',
    width: 110,
    slot: true,
  },
  'faHuoCode': {
    title: '发运单号',
    width: 120
  },
  'planTypeTextView': {
    title: '计划类型',
    width: 180
  },
  'saleCenterTextView': {
    title: '营销单元',
    width: 150
  },
  'mcShort': {
    title: '所属基地',
    width: 150
  },
  'customerCode': {
    title: '客户编码',
    width: 160
  },
  'customerName': {
    title: '订单客户',
    width: 250
  },
  'billCustomer': {
    title: '开票客户',
    width: 250
  },
  'zzfld00001c': {
    title: '六位编码',
    width: 100
  },
  'productDesc': {
    title: '产品',
    width: 400
  },
  'wantQuantity': {
    title: '要货量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'kaStoreFullname': {
    title: 'KA卖场全称',
    width: 200
  },
  'kaStoreShortname': {
    title: 'KA卖场简称',
    width: 200
  },
  'kaStoreArea': {
    title: '卖场区域'
  },
  'remark': {
    title: '备注',
    width: 250
  },
  'isShunt': {
    title: '是否分流',
    slot: true,
    width: 110
  },
  'shuntDealer': {
    title: '分流经销商'
  },
  'channelsTypeTextView': {
    title: '渠道类型',
    width: 120
  },
  'shuntChannelsTypeTextView': {
    title: '分流渠道类型',
    width: 120
  },
  'receiveUnitCode': {
    title: '收货单位编码',
    type: 'input'
  },
  'receiveUnitName': {
    title: '收货单位',
    width: 200
  },
  'spurtCodeUnitName': {
    title: '喷码单位',
    width: 200
  },
  'contacPerson': {
    title: '收货联系人'
  },
  'contactNumber': {
    title: '收货联系电话'
  },
  'receiveAddress': {
    title: '收货地址',
    width: 300
  },
  'createdDate': {
    title: '创建日期',
    width: 140
  },
  'handleNode': {
    title: '节点'
  },
  'billStatusTextView': {
    title: '状态',
    width: 90
  },
  'ajResult': {
    title: '推送安吉标记',
    slot: true,
    width: 130
  },
  'cancelType': {
    title: '取消类型'
  },
  'cancelReason': {
    title: '取消原因'
  },
  'isPcj': {
    title: '是否瓶储',
    slot: true,
    width: 120
  },
  'saveEnddate': {
    title: '瓶储截止日期'
  },
  'sendTime': {
    title: '推送日期',
    width: 140
  },
  'zcustomName': {
    title: '定制名称',
    width: 110
  },
  'billCode': {
    title: '单据编号',
    width: 150
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliverySearch.js